<template>
  <div>
    <div>
      <el-radio-group
        v-model="parameter.crawlerType"
        @input="crawlerTypeChange"
        :disabled="isDisabled"
      >
        <el-radio :label="1">红网百姓呼声</el-radio>
        <el-radio :label="2">问政湖南</el-radio>
        <el-radio :label="3">投诉直通车</el-radio>
        <el-radio :label="4">领导留言板</el-radio>
      </el-radio-group>
    </div>
    <div style="height: 20px"></div>
    <div v-show="parameter.crawlerType == '1'">
      <!-- 红网百姓呼声 -->
      <el-form ref="redform" :model="parameter" label-width="80px">
        <el-form-item label="标题名称">
          <el-input v-model="parameter.title" placeholder="请填写标题" />
        </el-form-item>
        <el-form-item label="地市编码">
          <el-input
            v-model="redNetParameter.CityId"
            placeholder="编码为大于0的整数"
          />
        </el-form-item>
        <el-form-item label="区县编码">
          <el-input
            v-model="redNetParameter.AreaId"
            placeholder="编码为大于0的整数"
          />
        </el-form-item>
        <el-form-item label="是否启用">
          <el-checkbox v-model="parameter.isUse" />
        </el-form-item>
      </el-form>
    </div>
    <div v-show="parameter.crawlerType == '2'">
      <!-- 问政湖南 -->
      <el-form ref="wzform" :model="parameter" label-width="80px">
        <el-form-item label="标题名称">
          <el-input v-model="parameter.title" placeholder="请填写标题" />
        </el-form-item>
        <el-form-item label="领导编码">
          <el-input v-model="wzhnParameter.LeaderId" />
        </el-form-item>
        <el-form-item label="是否启用">
          <el-checkbox v-model="parameter.isUse" />
        </el-form-item>
      </el-form>
    </div>
    <div v-show="parameter.crawlerType == '3'">
      <!-- 投诉直通车 -->
      <el-form ref="tsform" :model="parameter" label-width="80px">
        <el-form-item label="标题名称">
          <el-input v-model="parameter.title" placeholder="请填写标题" />
        </el-form-item>
        <el-form-item label="区县编码">
          <el-input v-model="tsztcParameter.AreaId" />
        </el-form-item>
        <el-form-item label="是否启用">
          <el-checkbox v-model="parameter.isUse" />
        </el-form-item>
      </el-form>
    </div>
    <div v-show="parameter.crawlerType == '4'">
      <!-- 领导留言板 -->
      <el-form ref="leaderform" :model="parameter" label-width="80px">
        <el-form-item label="标题名称">
          <el-input v-model="parameter.title" placeholder="请填写标题" />
        </el-form-item>
        <el-form-item label="签名编码">
          <el-input v-model="leaderParameter.Signature" />
        </el-form-item>
        <el-form-item label="区县编码">
          <el-input v-model="leaderParameter.FId" />
        </el-form-item>
        <el-form-item label="留言类型">
          <el-input
            v-model="leaderParameter.TypeId"
            placeholder="咨询1 投诉3 建言5"
          />
        </el-form-item>
        <el-form-item label="是否启用">
          <el-checkbox v-model="parameter.isUse" />
        </el-form-item>
      </el-form>
    </div>
    <div class="text-red">
      {{ msg }}
    </div>
    <div style="text-align: right">
      <el-button @click="handleClose">取 消</el-button>
      <el-button type="primary" @click="handleOk">{{
        parameter.id == "" ? "创 建" : "修 改"
      }}</el-button>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    crawler: {
      type: Object,
    },
  },
  watch: {
    crawler: {
      handler(newVal, oldVal) {
        if (Object.keys(newVal).length === 0) {
          this.isDisabled = false;
          this.parameter.id = "";
          this.parameter.title = "";
          this.parameter.crawlerType = 1;
          this.parameter.isUse = true;
          this.redNetParameter.CityId = "";
          this.redNetParameter.AreaId = "";
        } else {
          this.isDisabled = true;
          this.parameter.id = newVal.id;
          this.parameter.title = newVal.title;
          this.parameter.crawlerType = newVal.crawlerType;
          this.parameter.isUse = newVal.isUse;
          if (newVal.crawlerType == 1) {
            this.redNetParameter = JSON.parse(newVal.params);
          } else if (newVal.crawlerType == 2) {
            this.wzhnParameter = JSON.parse(newVal.params);
          } else if (newVal.crawlerType == 3) {
            this.tsztcParameter = JSON.parse(newVal.params);
          } else if (newVal.crawlerType == 4) {
            this.leaderParameter = JSON.parse(newVal.params);
          }
        }
      },
      immediate: true, //第一次执行就监听
    },
  },
  data() {
    return {
      isDisabled: true,
      parameter: {
        id: "",
        title: "",
        crawlerType: 1,
        isUse: true,
        params: "",
      },
      redNetParameter: {
        CityId: "",
        AreaId: "",
      },
      wzhnParameter: {
        //是否为列表
        IsList: 1,
        //答复类型：0-未办理 1-已办理 2-办理中 3-全部
        IsReply: 3,
        //领导id
        LeaderId: 0,
        PageIndex: 1,
        PageNum: 10,
      },
      tsztcParameter: {
        //区域id
        AreaId: 0,
        //第几页
        PageIndex: 1,
      },
      leaderParameter: {
        //签名
        Signature: "",
        //编码
        FId: "",
        //类型
        TypeId: "",
        Rows: 10,
        OrderType: 2,
      },
      msg: "",
    };
  },
  methods: {
    handleClose() {
      this.$emit("close");
    },
    crawlerTypeChange(value) {
      this.msg = "";
      if (value == 1) {
      } else if (value == 2) {
      } else if (value == 3) {
      } else if (value == 4) {
      }
    },
    handleOk() {
      this.msg = "";
      let data = this.parameter;
      if (data.crawlerType == 1) {
        data.params = this.redNetParameter;
        //为空
        if (
          data.title == "" ||
          data.params.CityId == "" ||
          data.params.AreaId == ""
        ) {
          this.msg = "内容不能为空";
          return;
        }
        //非整数
        if (
          !this.Common.isInt(data.params.CityId) ||
          !this.Common.isInt(data.params.AreaId)
        ) {
          this.msg = "编码必须为大于0的整数";
          return;
        }
      } else if (data.crawlerType == 2) {
        data.params = this.wzhnParameter;
      } else if (data.crawlerType == 3) {
        data.params = this.tsztcParameter;
      } else if (data.crawlerType == 4) {
        data.params = this.leaderParameter;
      } else {
        return;
      }
      // console.log(data)
      this.$emit("ok", data);
    },
  },
};
</script>
